import type { FaireProductEntity } from "../../entity_types/product";

export const p_vjgaftdwvd: FaireProductEntity = {
  token: "p_vjgaftdwvd",
  type: "product",
  name: "Italian Olivewood Box Cheese Grater",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/50b501b40cae3f3d9ef0080770f38dcf4f47b50c3d6a19d66efccec8fd04fde6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6ecb4059b79c696125ff00f878f7c37f51f817d073e27bb43f2c4b5b6672d99c.jpeg",
    "https://cdn.faire.com/fastly/97f1fd14abd2f4b15e17fbb9841ace58dd6ac99d119882c1d2f9fde989e00873.jpeg",
    "https://cdn.faire.com/fastly/21a9ec96fd9121203ed9c5c61afee8a9c831e08e7cc2f7ad6567c7e6281bdb9a.jpeg",
    "https://cdn.faire.com/fastly/a7740a140ad50ca93e181bf4728b04037cad11ac39479211c5c245b904f3f916.jpeg",
    "https://cdn.faire.com/fastly/64d375a39eb9922d8913cd5c36cb848eb173744bdc1b7148ab333368c5dd21ae.jpeg",
    "https://cdn.faire.com/fastly/4bcb0289137201b8288a037ad1a0a75eb0883a51e853cf6e15ee2f6dffe15f62.jpeg",
    "https://cdn.faire.com/fastly/4e49fa932adff96a14a307a412ede0e0f86ff07296543c8220e39bcc8e84c49b.jpeg",
    "https://cdn.faire.com/fastly/f5bf5a19234f90137d5c6ad2bc9c7ddac69a4afa5eb1fd0fc60889d2242bb50c.jpeg",
  ],
  priceDollars: 20,
  description:
    "It's all about the presentation in Italian cooking. Elevate your pasta night while keeping it simple and convenient. Our Italian Olive Wood box cheese grater is ideal for serving up fresh parmesan, Romano or asiago cheeses with a sharp metal grate sized for hard cheese and an olive wood box to catch shreds and minimize mess. \n\t\t- Crafted from beautifully grained, sustainably sourced Italian olive wood\n\t\t- Grate traditional hard cheeses in style \n\t\t- Made in Italy\n\nCARE: \nHand wash only, occasionally coat with olive oil or mineral oil to keep wood looking its best. \n\nABOUT: \nCrafted in the province of Umbria, Italy, our artisans use centuries-old tradition that produces unique pieces made from pure olive wood. The family preserves Italian history by using time-tested, hands-on techniques to craft heirloom-quality kitchen utensils and tabletop items that are as beautiful as they are functional. The famous Italian attention to design shines in every piece. ",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:23.530Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
